<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card
            color="#337ab7"
            dark
        >
          <v-card-title class="text-h5 d-flex pl-0 ml-5">
            <v-icon x-large class="text-white"> touch_app</v-icon>
            <div class="text-white ml-auto">
              <div class="total-text">{{ mainDashboardInfo.total }}</div>
              <div>{{ $t('display/dashboard:labels.total') }}</div>
            </div>

          </v-card-title>

          <v-card-actions>
            <a :href="getLink('total')" class="view-link color-total">{{ $t('display/dashboard:labels.view-details') }}</a>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
            color="#5cb85c"
            dark
        >
          <v-card-title class="text-h5 d-flex pl-0 ml-5">
            <v-icon x-large class="text-white"> thumb_up</v-icon>
            <div class="text-white ml-auto">
              <div class="total-text">{{ mainDashboardInfo.active }}</div>
              <div>{{ $t('common:active') }}</div>
            </div>

          </v-card-title>

          <v-card-actions>
            <a :href="getLink('active')" class="view-link color-active">{{ $t('display/dashboard:labels.view-details') }}</a>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
            color="#f0ad4e"
            dark
        >
          <v-card-title class="text-h5 d-flex pl-0 ml-5">
            <v-icon x-large class="text-white"> pan_tool</v-icon>
            <div class="text-white ml-auto">
              <div class="total-text">{{ mainDashboardInfo.deactivated }}</div>
              <div>{{ $t('display/dashboard:labels.deactivated') }}</div>
            </div>

          </v-card-title>

          <v-card-actions>
            <a :href="getLink('deactivated')" class="view-link color-deactivated">{{ $t('display/dashboard:labels.view-details') }}</a>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
            color="#d9534f"
            dark
        >
          <v-card-title class="text-h5 d-flex pl-0 ml-5">
            <v-icon class="text-white" large> thumb_down</v-icon>
            <div class="text-white ml-auto">
              <div class="total-text">{{ mainDashboardInfo.offline }}</div>
              <div>{{ $t('display/dashboard:labels.offline') }}</div>
            </div>
          </v-card-title>

          <v-card-actions>
            <a :href="getLink('offline')" class="view-link color-offline">{{ $t('display/dashboard:labels.view-details') }}</a>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card class="total-card">
          <v-card-title>
            <v-col class="display-1">
              <iframe
                  src="https://statistic.gratis-notruf.com/public/question/0606050d-a4ff-4365-96ea-4ebe77375f5b"
                  frameborder="0"
                  width="100%"
                  height="100%"
                  allowtransparency
              ></iframe>
            </v-col>
          </v-card-title>
          <v-card-actions>
            {{ $t('display/dashboard:labels.impressionsToday') }}
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="total-card">
          <v-card-title>
            <v-col class="display-1">
              <iframe
                  src="https://statistic.gratis-notruf.com/public/question/26651dc1-daaa-47b2-ab54-e0f93a063927"
                  frameborder="0"
                  width="100%"
                  height="100%"
                  allowtransparency
              ></iframe>
            </v-col>
          </v-card-title>
          <v-card-actions>
            {{ $t('display/dashboard:labels.impressionsLast24') }}
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="total-card">
          <v-card-title>
            <v-col class="display-1">
              <iframe
                  src="https://statistic.gratis-notruf.com/public/question/aa6b68a1-d741-4072-aeb3-fde9e265f108"
                  frameborder="0"
                  width="100%"
                  height="100%"
                  allowtransparency
              ></iframe>
            </v-col>
          </v-card-title>
          <v-card-actions>
            {{ $t('display/dashboard:labels.impressionsLastWeek') }}
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card class="total-card">
          <v-card-title>
            <v-col class="display-1">
              <iframe
                  src="https://statistic.gratis-notruf.com/public/question/1b77f1df-ca51-4a4c-bad6-0debf6c57a42"
                  frameborder="0"
                  width="100%"
                  height="100%"
                  allowtransparency
              ></iframe>
            </v-col>
          </v-card-title>
          <v-card-actions>
            {{ $t('display/dashboard:labels.impressionsLastMonth') }}
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ElevatorService from "@/modules/display/services/elevator-service";
import Utils from '@/modules/core/services/utils';

export default {
  name: "MainCards",
  data() {
    return {
      mainDashboardInfo: {},
      playouts: {
        impressionsToday: 0,
        impressionsLast24: 0,
        impressionsLastWeek: 0,
        impressionsLastMonth: 0
      }

    }
  },
  methods: {
    getPlayouts(playoutId, playoutType) {
      ElevatorService.getPlayouts(
        playoutId,
        (response) => {
          this.playouts[playoutType] = response.data[0].sum;
        },
        () => {
          Utils.showFailureSnackbar(
            this.$t('snackbar:load-failure', {name: this.$t('display/dashboard:labels.' + playoutType)})
          );
        }
      );
    },
    getLink(attribute) {
      let url = this.$router.resolve({
        name: 'Elevator table'
      });

      return url.href + '?' + attribute;
    }
  },
  created() {
    ElevatorService.getDashboardData(
      '',
      (response) => {
        this.mainDashboardInfo = response.data;
      },
      () => {
        this.$t('snackbar:load-failure', {name: this.$t('common:dashboard')})
      }
    );
  }
}
</script>
